module.exports = __webpack_public_path__ + "static/media/web_buttons_mobile_phone.ac656668.svg";